import { Tick } from '../../models/tick';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  signal,
} from '@angular/core';

@Component({
  selector: 'tmx-meter',
  templateUrl: './meter.component.html',
  styleUrl: './meter.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeterComponent {
  private readonly store = {
    min: 0,
    max: 0,
    tickStep: 1,
  };

  ticks = signal([] as Tick[]);

  @Input() set min(value: number) {
    this.store.min = value;
    this.update();
  }

  @Input() set max(value: number) {
    this.store.max = value;
    this.update();
  }

  @Input() set tickStep(value: number) {
    this.store.tickStep = value;
    this.update();
  }

  private update() {
    const ticks: Tick[] = [];

    for (
      let tick = this.store.min, isMark = true;
      tick <= this.store.max;
      tick += this.store.tickStep, isMark = !isMark
    ) {
      ticks.push(new Tick(tick, isMark));
    }

    this.ticks.set(ticks);
  }
}
